import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { Button, Form, Table } from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import { compName } from "../../../../utils/constant";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import AddWidgetModal from "../../AddWidgetModal";
import WidgetDetailModal from "../../WidgetDetailModal";
import { commonService } from "../../../../utils/commonService";
import moment from "moment";

const RunningStar = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
  strData,
  setStrData,
  fileImportLoading,
  tableDataRefSecond,
  strDataRef,
}) => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const weekDayArr = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Total",
  ];
  // const [strData, setStrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  // const tableObj = {
  //   Sunday: {},
  //   Monday: {},
  //   Tuesday: {},
  //   Wednesday: {},
  //   Thursday: {},
  //   Friday: {},
  //   Saturday: {},
  //   Total: {},
  // };
  // const tableDataRefSecond = useRef(tableObj);
  const [clickedTr, setClickedTr] = useState({
    mainRow: "",
    subRow: "",
    day: "",
    field: "",
  });

  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [widgetModal, setWidgetModal] = useState(false);
  const widgetDetailRef = useRef();
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };

  // useEffect(() => {
  //   if (api === 0) {
  //   } else {
  //     if (para?.propertyCode) {
  //       getStrReport();
  //     }
  //   }
  // }, [para?.propertyCode]);

  const clickOutSide = (e) => {
    if (e.target.nodeName.toLowerCase() === "input") {
      return;
    }
    setClickedTr({
      mainRow: "",
      subRow: "",
      day: "",
      field: "",
    });
  };

  useEffect(() => {
    document.addEventListener("click", clickOutSide);

    return () => {
      document.removeEventListener("click", clickOutSide);
    };
  }, []);

  const [tblids, settblids] = useState({
    runningStr: commonService.GenerateGUID(),
  });

  const handleSave = async () => {
    setSubmitLoading(true);
    let newStrData = strData?.map((item, index) => {
      Object.keys(item)?.map((keyItem, keyIndex) => {
        if (item[keyItem] === "" || item[keyItem] === undefined) {
          item[keyItem] = null;
        }
      });
      return item;
    });
    let saveResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.STR_REPORT_REVPAK.RUNNING_STR_SAVE,
        body: {
          report_data: newStrData,
          propertyCode: para?.propertyCode,
        },
      },
      false
    );

    let response = apiResponse(true, saveResponse, setSubmitLoading);

    if (response?.isValidate) {
    }

    if (!response?.isValidate) {
    }
  };

  const calculateAvg = (keyName) => {
    let total = 0;
    Object.entries(tableDataRefSecond.current)?.map(([key, value]) => {
      if (key !== "Total") {
        total = total + parseFloat(value?.[keyName]);
      }
    });
    let avg = 0;
    if (total) {
      avg = total / 7;
      avg = avg?.toFixed(2);
    }

    tableDataRefSecond.current.Total[keyName] = avg;
    strDataRef.current = strDataRef.current?.map((item, index) => {
      if (item?.Weekday === null) {
        item[keyName] = avg;
      }
      return item;
    });
    // return avg;
  };

  //   const inputFile = useRef();
  //   const [fileImportLoading, setFileImportLoading] = useState(false);

  //   const handleImport = async (file) => {
  //     setFileImportLoading(true);
  //     let fileResponse = await apiCall(
  //       {
  //         method: "POST",
  //         url:
  //           API_URL.BASE_API_URL.RevenueManagement +
  //           API_URL.STR_REPORT_REVPAK.READ_STR_ANALYSIS,
  //         body: {
  //           file: file,
  //         },
  //       },
  //       true
  //     );

  //     let response = apiResponse(false, fileResponse);

  //     if (response?.isValidate) {
  //       let dataFromApi = response?.data?.data.day28;

  //       //strData
  //       if (dataFromApi && dataFromApi.length === 9) {
  //         let _strData = [...strData];
  //         let Sunday = _strData.filter((i) => i.Weekday === "Sunday");
  //         let Monday = _strData.filter((i) => i.Weekday === "Monday");
  //         let Tuesday = _strData.filter((i) => i.Weekday === "Tuesday");
  //         let Wednesday = _strData.filter((i) => i.Weekday === "Wednesday");
  //         let Thursday = _strData.filter((i) => i.Weekday === "Thursday");
  //         let Friday = _strData.filter((i) => i.Weekday === "Friday");
  //         let Saturday = _strData.filter((i) => i.Weekday === "Saturday");
  //         let Total = _strData.filter((i) => i.Weekday === "Total");

  //         if (
  //           Sunday &&
  //           Monday &&
  //           Tuesday &&
  //           Wednesday &&
  //           Thursday &&
  //           Friday &&
  //           Saturday &&
  //           Total
  //         ) {
  //           if (
  //             Sunday.length > 0 &&
  //             Monday.length > 0 &&
  //             Tuesday.length > 0 &&
  //             Wednesday.length > 0 &&
  //             Thursday.length > 0 &&
  //             Friday.length > 0 &&
  //             Saturday.length > 0 &&
  //             Total.length > 0
  //           ) {
  //             //Occ Start
  //             Sunday[0].OccMyProperty = parseFloat(dataFromApi[0][0])?.toFixed(2);
  //             Sunday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][1]
  //             )?.toFixed(2);
  //             Sunday[0].OccMyPropertyLy = parseFloat(dataFromApi[0][2])?.toFixed(
  //               2
  //             );

  //             Monday[0].OccMyProperty = parseFloat(dataFromApi[0][3])?.toFixed(2);
  //             Monday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][4]
  //             )?.toFixed(2);
  //             Monday[0].OccMyPropertyLy = parseFloat(dataFromApi[0][5])?.toFixed(
  //               2
  //             );

  //             Tuesday[0].OccMyProperty = parseFloat(dataFromApi[0][6])?.toFixed(
  //               2
  //             );
  //             Tuesday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][7]
  //             )?.toFixed(2);
  //             Tuesday[0].OccMyPropertyLy = parseFloat(dataFromApi[0][8])?.toFixed(
  //               2
  //             );

  //             Wednesday[0].OccMyProperty = parseFloat(dataFromApi[0][9])?.toFixed(
  //               2
  //             );
  //             Wednesday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][10]
  //             )?.toFixed(2);
  //             Wednesday[0].OccMyPropertyLy = parseFloat(
  //               dataFromApi[0][11]
  //             )?.toFixed(2);

  //             Thursday[0].OccMyProperty = parseFloat(dataFromApi[0][12])?.toFixed(
  //               2
  //             );
  //             Thursday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][13]
  //             )?.toFixed(2);
  //             Thursday[0].OccMyPropertyLy = parseFloat(
  //               dataFromApi[0][14]
  //             )?.toFixed(2);

  //             Friday[0].OccMyProperty = parseFloat(dataFromApi[0][15])?.toFixed(
  //               2
  //             );
  //             Friday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][16]
  //             )?.toFixed(2);
  //             Friday[0].OccMyPropertyLy = parseFloat(dataFromApi[0][17])?.toFixed(
  //               2
  //             );

  //             Saturday[0].OccMyProperty = parseFloat(dataFromApi[0][18])?.toFixed(
  //               2
  //             );
  //             Saturday[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][19]
  //             )?.toFixed(2);
  //             Saturday[0].OccMyPropertyLy = parseFloat(
  //               dataFromApi[0][20]
  //             )?.toFixed(2);

  //             Total[0].OccMyProperty = parseFloat(dataFromApi[0][21])?.toFixed(2);
  //             Total[0].OccMyPropertyChange = parseFloat(
  //               dataFromApi[0][22]
  //             )?.toFixed(2);
  //             Total[0].OccMyPropertyLy = parseFloat(dataFromApi[0][23])?.toFixed(
  //               2
  //             );

  //             Sunday[0].OccCompset = parseFloat(dataFromApi[1][0])?.toFixed(2);
  //             Sunday[0].OccCompsetChange = parseFloat(dataFromApi[1][1])?.toFixed(
  //               2
  //             );
  //             Sunday[0].OccCompsetLy = parseFloat(dataFromApi[1][2])?.toFixed(2);

  //             Monday[0].OccCompset = parseFloat(dataFromApi[1][3])?.toFixed(2);
  //             Monday[0].OccCompsetChange = parseFloat(dataFromApi[1][4])?.toFixed(
  //               2
  //             );
  //             Monday[0].OccCompsetLy = parseFloat(dataFromApi[1][5])?.toFixed(2);

  //             Tuesday[0].OccCompset = parseFloat(dataFromApi[1][6])?.toFixed(2);
  //             Tuesday[0].OccCompsetChange = parseFloat(
  //               dataFromApi[1][7]
  //             )?.toFixed(2);
  //             Tuesday[0].OccCompsetLy = parseFloat(dataFromApi[1][8])?.toFixed(2);

  //             Wednesday[0].OccCompset = parseFloat(dataFromApi[1][9])?.toFixed(2);
  //             Wednesday[0].OccCompsetChange = parseFloat(
  //               dataFromApi[1][10]
  //             )?.toFixed(2);
  //             Wednesday[0].OccCompsetLy = parseFloat(dataFromApi[1][11])?.toFixed(
  //               2
  //             );

  //             Thursday[0].OccCompset = parseFloat(dataFromApi[1][12])?.toFixed(2);
  //             Thursday[0].OccCompsetChange = parseFloat(
  //               dataFromApi[1][13]
  //             )?.toFixed(2);
  //             Thursday[0].OccCompsetLy = parseFloat(dataFromApi[1][14])?.toFixed(
  //               2
  //             );

  //             Friday[0].OccCompset = parseFloat(dataFromApi[1][15])?.toFixed(2);
  //             Friday[0].OccCompsetChange = parseFloat(
  //               dataFromApi[1][16]
  //             )?.toFixed(2);
  //             Friday[0].OccCompsetLy = parseFloat(dataFromApi[1][17])?.toFixed(2);

  //             Saturday[0].OccCompset = parseFloat(dataFromApi[1][18])?.toFixed(2);
  //             Saturday[0].OccCompsetChange = parseFloat(
  //               dataFromApi[1][19]
  //             )?.toFixed(2);
  //             Saturday[0].OccCompsetLy = parseFloat(dataFromApi[1][20])?.toFixed(
  //               2
  //             );

  //             Total[0].OccCompset = parseFloat(dataFromApi[1][21])?.toFixed(2);
  //             Total[0].OccCompsetChange = parseFloat(dataFromApi[1][22])?.toFixed(
  //               2
  //             );
  //             Total[0].OccCompsetLy = parseFloat(dataFromApi[1][23])?.toFixed(2);

  //             Sunday[0].OccIndex = parseFloat(dataFromApi[2][0])?.toFixed(2);
  //             Sunday[0].OccIndexChange = parseFloat(dataFromApi[2][1])?.toFixed(
  //               2
  //             );
  //             Sunday[0].OccIndexLy = parseFloat(dataFromApi[2][2])?.toFixed(2);

  //             Monday[0].OccIndex = parseFloat(dataFromApi[2][3])?.toFixed(2);
  //             Monday[0].OccIndexChange = parseFloat(dataFromApi[2][4])?.toFixed(
  //               2
  //             );
  //             Monday[0].OccIndexLy = parseFloat(dataFromApi[2][5])?.toFixed(2);

  //             Tuesday[0].OccIndex = parseFloat(dataFromApi[2][6])?.toFixed(2);
  //             Tuesday[0].OccIndexChange = parseFloat(dataFromApi[2][7])?.toFixed(
  //               2
  //             );
  //             Tuesday[0].OccIndexLy = parseFloat(dataFromApi[2][8])?.toFixed(2);

  //             Wednesday[0].OccIndex = parseFloat(dataFromApi[2][9])?.toFixed(2);
  //             Wednesday[0].OccIndexChange = parseFloat(
  //               dataFromApi[2][10]
  //             )?.toFixed(2);
  //             Wednesday[0].OccIndexLy = parseFloat(dataFromApi[2][11])?.toFixed(
  //               2
  //             );

  //             Thursday[0].OccIndex = parseFloat(dataFromApi[2][12])?.toFixed(2);
  //             Thursday[0].OccIndexChange = parseFloat(
  //               dataFromApi[2][13]
  //             )?.toFixed(2);
  //             Thursday[0].OccIndexLy = parseFloat(dataFromApi[2][14])?.toFixed(2);

  //             Friday[0].OccIndex = parseFloat(dataFromApi[2][15])?.toFixed(2);
  //             Friday[0].OccIndexChange = parseFloat(dataFromApi[2][16])?.toFixed(
  //               2
  //             );
  //             Friday[0].OccIndexLy = parseFloat(dataFromApi[2][17])?.toFixed(2);

  //             Saturday[0].OccIndex = parseFloat(dataFromApi[2][18])?.toFixed(2);
  //             Saturday[0].OccIndexChange = parseFloat(
  //               dataFromApi[2][19]
  //             )?.toFixed(2);
  //             Saturday[0].OccIndexLy = parseFloat(dataFromApi[2][20])?.toFixed(2);

  //             Total[0].OccIndex = parseFloat(dataFromApi[2][21])?.toFixed(2);
  //             Total[0].OccIndexChange = parseFloat(dataFromApi[2][22])?.toFixed(
  //               2
  //             );
  //             Total[0].OccIndexLy = parseFloat(dataFromApi[2][23])?.toFixed(2);

  //             //Occ End

  //             //ADR Start
  //             Sunday[0].AdrMyProperty = parseFloat(dataFromApi[3][0])?.toFixed(2);
  //             Sunday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][1]
  //             )?.toFixed(2);
  //             Sunday[0].AdrMyPropertyLy = parseFloat(dataFromApi[3][2])?.toFixed(
  //               2
  //             );

  //             Monday[0].AdrMyProperty = parseFloat(dataFromApi[3][3])?.toFixed(2);
  //             Monday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][4]
  //             )?.toFixed(2);
  //             Monday[0].AdrMyPropertyLy = parseFloat(dataFromApi[3][5])?.toFixed(
  //               2
  //             );

  //             Tuesday[0].AdrMyProperty = parseFloat(dataFromApi[3][6])?.toFixed(
  //               2
  //             );
  //             Tuesday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][7]
  //             )?.toFixed(2);
  //             Tuesday[0].AdrMyPropertyLy = parseFloat(dataFromApi[3][8])?.toFixed(
  //               2
  //             );

  //             Wednesday[0].AdrMyProperty = parseFloat(dataFromApi[3][9])?.toFixed(
  //               2
  //             );
  //             Wednesday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][10]
  //             )?.toFixed(2);
  //             Wednesday[0].AdrMyPropertyLy = parseFloat(
  //               dataFromApi[3][11]
  //             )?.toFixed(2);

  //             Thursday[0].AdrMyProperty = parseFloat(dataFromApi[3][12])?.toFixed(
  //               2
  //             );
  //             Thursday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][13]
  //             )?.toFixed(2);
  //             Thursday[0].AdrMyPropertyLy = parseFloat(
  //               dataFromApi[3][14]
  //             )?.toFixed(2);

  //             Friday[0].AdrMyProperty = parseFloat(dataFromApi[3][15])?.toFixed(
  //               2
  //             );
  //             Friday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][16]
  //             )?.toFixed(2);
  //             Friday[0].AdrMyPropertyLy = parseFloat(dataFromApi[3][17])?.toFixed(
  //               2
  //             );

  //             Saturday[0].AdrMyProperty = parseFloat(dataFromApi[3][18])?.toFixed(
  //               2
  //             );
  //             Saturday[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][19]
  //             )?.toFixed(2);
  //             Saturday[0].AdrMyPropertyLy = parseFloat(
  //               dataFromApi[3][20]
  //             )?.toFixed(2);

  //             Total[0].AdrMyProperty = parseFloat(dataFromApi[3][21])?.toFixed(2);
  //             Total[0].AdrMyPropertyChange = parseFloat(
  //               dataFromApi[3][22]
  //             )?.toFixed(2);
  //             Total[0].AdrMyPropertyLy = parseFloat(dataFromApi[3][23])?.toFixed(
  //               2
  //             );

  //             Sunday[0].AdrCompset = parseFloat(dataFromApi[4][0])?.toFixed(2);
  //             Sunday[0].AdrCompsetChange = parseFloat(dataFromApi[4][1])?.toFixed(
  //               2
  //             );
  //             Sunday[0].AdrCompsetLy = parseFloat(dataFromApi[4][2])?.toFixed(2);

  //             Monday[0].AdrCompset = parseFloat(dataFromApi[4][3])?.toFixed(2);
  //             Monday[0].AdrCompsetChange = parseFloat(dataFromApi[4][4])?.toFixed(
  //               2
  //             );
  //             Monday[0].AdrCompsetLy = parseFloat(dataFromApi[4][5])?.toFixed(2);

  //             Tuesday[0].AdrCompset = parseFloat(dataFromApi[4][6])?.toFixed(2);
  //             Tuesday[0].AdrCompsetChange = parseFloat(
  //               dataFromApi[4][7]
  //             )?.toFixed(2);
  //             Tuesday[0].AdrCompsetLy = parseFloat(dataFromApi[4][8])?.toFixed(2);

  //             Wednesday[0].AdrCompset = parseFloat(dataFromApi[4][9])?.toFixed(2);
  //             Wednesday[0].AdrCompsetChange = parseFloat(
  //               dataFromApi[4][10]
  //             )?.toFixed(2);
  //             Wednesday[0].AdrCompsetLy = parseFloat(dataFromApi[4][11])?.toFixed(
  //               2
  //             );

  //             Thursday[0].AdrCompset = parseFloat(dataFromApi[4][12])?.toFixed(2);
  //             Thursday[0].AdrCompsetChange = parseFloat(
  //               dataFromApi[4][13]
  //             )?.toFixed(2);
  //             Thursday[0].AdrCompsetLy = parseFloat(dataFromApi[4][14])?.toFixed(
  //               2
  //             );

  //             Friday[0].AdrCompset = parseFloat(dataFromApi[4][15])?.toFixed(2);
  //             Friday[0].AdrCompsetChange = parseFloat(
  //               dataFromApi[4][16]
  //             )?.toFixed(2);
  //             Friday[0].AdrCompsetLy = parseFloat(dataFromApi[4][17])?.toFixed(2);

  //             Saturday[0].AdrCompset = parseFloat(dataFromApi[4][18])?.toFixed(2);
  //             Saturday[0].AdrCompsetChange = parseFloat(
  //               dataFromApi[4][19]
  //             )?.toFixed(2);
  //             Saturday[0].AdrCompsetLy = parseFloat(dataFromApi[4][20])?.toFixed(
  //               2
  //             );

  //             Total[0].AdrCompset = parseFloat(dataFromApi[4][21])?.toFixed(2);
  //             Total[0].AdrCompsetChange = parseFloat(dataFromApi[4][22])?.toFixed(
  //               2
  //             );
  //             Total[0].AdrCompsetLy = parseFloat(dataFromApi[4][23])?.toFixed(2);

  //             Sunday[0].AdrIndex = parseFloat(dataFromApi[5][0])?.toFixed(2);
  //             Sunday[0].AdrIndexChange = parseFloat(dataFromApi[5][1])?.toFixed(
  //               2
  //             );
  //             Sunday[0].AdrIndexLy = parseFloat(dataFromApi[5][2])?.toFixed(2);

  //             Monday[0].AdrIndex = parseFloat(dataFromApi[5][3])?.toFixed(2);
  //             Monday[0].AdrIndexChange = parseFloat(dataFromApi[5][4])?.toFixed(
  //               2
  //             );
  //             Monday[0].AdrIndexLy = parseFloat(dataFromApi[5][5])?.toFixed(2);

  //             Tuesday[0].AdrIndex = parseFloat(dataFromApi[5][6])?.toFixed(2);
  //             Tuesday[0].AdrIndexChange = parseFloat(dataFromApi[5][7])?.toFixed(
  //               2
  //             );
  //             Tuesday[0].AdrIndexLy = parseFloat(dataFromApi[5][8])?.toFixed(2);

  //             Wednesday[0].AdrIndex = parseFloat(dataFromApi[5][9])?.toFixed(2);
  //             Wednesday[0].AdrIndexChange = parseFloat(
  //               dataFromApi[5][10]
  //             )?.toFixed(2);
  //             Wednesday[0].AdrIndexLy = parseFloat(dataFromApi[5][11])?.toFixed(
  //               2
  //             );

  //             Thursday[0].AdrIndex = parseFloat(dataFromApi[5][12])?.toFixed(2);
  //             Thursday[0].AdrIndexChange = parseFloat(
  //               dataFromApi[5][13]
  //             )?.toFixed(2);
  //             Thursday[0].AdrIndexLy = parseFloat(dataFromApi[5][14])?.toFixed(2);

  //             Friday[0].AdrIndex = parseFloat(dataFromApi[5][15])?.toFixed(2);
  //             Friday[0].AdrIndexChange = parseFloat(dataFromApi[5][16])?.toFixed(
  //               2
  //             );
  //             Friday[0].AdrIndexLy = parseFloat(dataFromApi[5][17])?.toFixed(2);

  //             Saturday[0].AdrIndex = parseFloat(dataFromApi[5][18])?.toFixed(2);
  //             Saturday[0].AdrIndexChange = parseFloat(
  //               dataFromApi[5][19]
  //             )?.toFixed(2);
  //             Saturday[0].AdrIndexLy = parseFloat(dataFromApi[5][20])?.toFixed(2);

  //             Total[0].AdrIndex = parseFloat(dataFromApi[5][21])?.toFixed(2);
  //             Total[0].AdrIndexChange = parseFloat(dataFromApi[5][22])?.toFixed(
  //               2
  //             );
  //             Total[0].AdrIndexLy = parseFloat(dataFromApi[5][23])?.toFixed(2);

  //             //ADR End

  //             //RevPAR Start
  //             Sunday[0].RevparMyProperty = parseFloat(dataFromApi[6][0])?.toFixed(
  //               2
  //             );
  //             Sunday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][1]
  //             )?.toFixed(2);
  //             Sunday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][2]
  //             )?.toFixed(2);

  //             Monday[0].RevparMyProperty = parseFloat(dataFromApi[6][3])?.toFixed(
  //               2
  //             );
  //             Monday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][4]
  //             )?.toFixed(2);
  //             Monday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][5]
  //             )?.toFixed(2);

  //             Tuesday[0].RevparMyProperty = parseFloat(
  //               dataFromApi[6][6]
  //             )?.toFixed(2);
  //             Tuesday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][7]
  //             )?.toFixed(2);
  //             Tuesday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][8]
  //             )?.toFixed(2);

  //             Wednesday[0].RevparMyProperty = parseFloat(
  //               dataFromApi[6][9]
  //             )?.toFixed(2);
  //             Wednesday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][10]
  //             )?.toFixed(2);
  //             Wednesday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][11]
  //             )?.toFixed(2);

  //             Thursday[0].RevparMyProperty = parseFloat(
  //               dataFromApi[6][12]
  //             )?.toFixed(2);
  //             Thursday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][13]
  //             )?.toFixed(2);
  //             Thursday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][14]
  //             )?.toFixed(2);

  //             Friday[0].RevparMyProperty = parseFloat(
  //               dataFromApi[6][15]
  //             )?.toFixed(2);
  //             Friday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][16]
  //             )?.toFixed(2);
  //             Friday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][17]
  //             )?.toFixed(2);

  //             Saturday[0].RevparMyProperty = parseFloat(
  //               dataFromApi[6][18]
  //             )?.toFixed(2);
  //             Saturday[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][19]
  //             )?.toFixed(2);
  //             Saturday[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][20]
  //             )?.toFixed(2);

  //             Total[0].RevparMyProperty = parseFloat(dataFromApi[6][21])?.toFixed(
  //               2
  //             );
  //             Total[0].RevparMyPropertyChange = parseFloat(
  //               dataFromApi[6][22]
  //             )?.toFixed(2);
  //             Total[0].RevparMyPropertyLy = parseFloat(
  //               dataFromApi[6][23]
  //             )?.toFixed(2);

  //             Sunday[0].RevparCompset = parseFloat(dataFromApi[7][0])?.toFixed(2);
  //             Sunday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][1]
  //             )?.toFixed(2);
  //             Sunday[0].RevparCompsetLy = parseFloat(dataFromApi[7][2])?.toFixed(
  //               2
  //             );

  //             Monday[0].RevparCompset = parseFloat(dataFromApi[7][3])?.toFixed(2);
  //             Monday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][4]
  //             )?.toFixed(2);
  //             Monday[0].RevparCompsetLy = parseFloat(dataFromApi[7][5])?.toFixed(
  //               2
  //             );

  //             Tuesday[0].RevparCompset = parseFloat(dataFromApi[7][6])?.toFixed(
  //               2
  //             );
  //             Tuesday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][7]
  //             )?.toFixed(2);
  //             Tuesday[0].RevparCompsetLy = parseFloat(dataFromApi[7][8])?.toFixed(
  //               2
  //             );

  //             Wednesday[0].RevparCompset = parseFloat(dataFromApi[7][9])?.toFixed(
  //               2
  //             );
  //             Wednesday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][10]
  //             )?.toFixed(2);
  //             Wednesday[0].RevparCompsetLy = parseFloat(
  //               dataFromApi[7][11]
  //             )?.toFixed(2);

  //             Thursday[0].RevparCompset = parseFloat(dataFromApi[7][12])?.toFixed(
  //               2
  //             );
  //             Thursday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][13]
  //             )?.toFixed(2);
  //             Thursday[0].RevparCompsetLy = parseFloat(
  //               dataFromApi[7][14]
  //             )?.toFixed(2);

  //             Friday[0].RevparCompset = parseFloat(dataFromApi[7][15])?.toFixed(
  //               2
  //             );
  //             Friday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][16]
  //             )?.toFixed(2);
  //             Friday[0].RevparCompsetLy = parseFloat(dataFromApi[7][17])?.toFixed(
  //               2
  //             );

  //             Saturday[0].RevparCompset = parseFloat(dataFromApi[7][18])?.toFixed(
  //               2
  //             );
  //             Saturday[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][19]
  //             )?.toFixed(2);
  //             Saturday[0].RevparCompsetLy = parseFloat(
  //               dataFromApi[7][20]
  //             )?.toFixed(2);

  //             Total[0].RevparCompset = parseFloat(dataFromApi[7][21])?.toFixed(2);
  //             Total[0].RevparCompsetChange = parseFloat(
  //               dataFromApi[7][22]
  //             )?.toFixed(2);
  //             Total[0].RevparCompsetLy = parseFloat(dataFromApi[7][23])?.toFixed(
  //               2
  //             );

  //             Sunday[0].RevparIndex = parseFloat(dataFromApi[8][0])?.toFixed(2);
  //             Sunday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][1]
  //             )?.toFixed(2);
  //             Sunday[0].RevparIndexLy = parseFloat(dataFromApi[8][2])?.toFixed(2);

  //             Monday[0].RevparIndex = parseFloat(dataFromApi[8][3])?.toFixed(2);
  //             Monday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][4]
  //             )?.toFixed(2);
  //             Monday[0].RevparIndexLy = parseFloat(dataFromApi[8][5])?.toFixed(2);

  //             Tuesday[0].RevparIndex = parseFloat(dataFromApi[8][6])?.toFixed(2);
  //             Tuesday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][7]
  //             )?.toFixed(2);
  //             Tuesday[0].RevparIndexLy = parseFloat(dataFromApi[8][8])?.toFixed(
  //               2
  //             );

  //             Wednesday[0].RevparIndex = parseFloat(dataFromApi[8][9])?.toFixed(
  //               2
  //             );
  //             Wednesday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][10]
  //             )?.toFixed(2);
  //             Wednesday[0].RevparIndexLy = parseFloat(
  //               dataFromApi[8][11]
  //             )?.toFixed(2);

  //             Thursday[0].RevparIndex = parseFloat(dataFromApi[8][12])?.toFixed(
  //               2
  //             );
  //             Thursday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][13]
  //             )?.toFixed(2);
  //             Thursday[0].RevparIndexLy = parseFloat(dataFromApi[8][14])?.toFixed(
  //               2
  //             );

  //             Friday[0].RevparIndex = parseFloat(dataFromApi[8][15])?.toFixed(2);
  //             Friday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][16]
  //             )?.toFixed(2);
  //             Friday[0].RevparIndexLy = parseFloat(dataFromApi[8][17])?.toFixed(
  //               2
  //             );

  //             Saturday[0].RevparIndex = parseFloat(dataFromApi[8][18])?.toFixed(
  //               2
  //             );
  //             Saturday[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][19]
  //             )?.toFixed(2);
  //             Saturday[0].RevparIndexLy = parseFloat(dataFromApi[8][20])?.toFixed(
  //               2
  //             );

  //             Total[0].RevparIndex = parseFloat(dataFromApi[8][21])?.toFixed(2);
  //             Total[0].RevparIndexChange = parseFloat(
  //               dataFromApi[8][22]
  //             )?.toFixed(2);
  //             Total[0].RevparIndexLy = parseFloat(dataFromApi[8][23])?.toFixed(2);

  //             //RevPAR End

  //             let dummyData = [];
  //             dummyData.push(Sunday[0]);
  //             dummyData.push(Monday[0]);
  //             dummyData.push(Tuesday[0]);
  //             dummyData.push(Wednesday[0]);
  //             dummyData.push(Thursday[0]);
  //             dummyData.push(Friday[0]);
  //             dummyData.push(Saturday[0]);
  //             dummyData.push(Total[0]);
  //             strDataRef.current = dummyData;
  //             setStrData(dummyData);
  //             handleSaveAfterImport(dummyData);
  //           }
  //         }
  //       }
  //     }

  //     setFileImportLoading(false);

  //     inputFile.current.value = "";
  //     inputFile.current.type = "text";
  //     inputFile.current.type = "file";
  //   };

  return (
    <div className="widget-container">
      <div className="running-report-div mb-3">
        <div></div>
        <div className="weekly-report-heading">
          <p>{`Running 28 Days (by Day of Week)`}</p>
        </div>
        <div>
          <div
            className={`special-btn-input-type-file ${
              fileImportLoading ? "disable-special-btn-input-type-file" : ""
            }`}
          >
            {/* <input
              ref={inputFile}
              type="file"
              accept=".xlsx,.xls"
              onChange={(e) => {
                if (e?.target?.files?.[0]) {
                  handleImport(e?.target?.files?.[0]);
                }
              }}
              disabled={fileImportLoading}
            /> */}
          </div>
        </div>
      </div>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu" style={{ right: "70px" }}>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("RunningStar", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.runningStr,
                  "Running 28 Days",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("RunningStar", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.runningStrReport,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("RunningStar", "menuicon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.runningStr}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.runningStr,
                  // "Running 28 Days"
                  `${para?.propertyCode}-Running 28 Days-${moment(
                    new Date()
                  ).format("MMDDYYYY")}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table table-responsive">
          <Table id={tblids.runningStr} responsive>
            <thead>
              <tr>
                <th className="border_right width50"></th>
                <th className="border_right width90"></th>
                {weekDayArr?.map((item, index) => {
                  if (item !== "Total") {
                    return (
                      <th
                        className="border_right text-center width50"
                        key={`${item}firstth`}
                        colSpan={3}
                      >
                        {item}
                      </th>
                    );
                  }
                })}
                <th className="width50 text-center" colSpan={2}>
                  Total
                </th>
              </tr>
              <tr>
                <th className="border_right"></th>
                <th className="border_right"></th>
                {weekDayArr?.map((item, index) => {
                  if (item !== "Total") {
                    return (
                      <React.Fragment key={`${item}secondth`}>
                        <th className="width50"></th>
                        <th className="width50">%Chg</th>
                        <th className="border_right width50">LY</th>
                      </React.Fragment>
                    );
                  }
                })}
                <th className="width50">AVG</th>
                <th className="width50">%CHG</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : strData ? (
                <>
                  {/* OCC */}
                  <tr className="shadowOnHover">
                    <td rowSpan={3} className="th-with-rowspan border_right">
                      Occupancy
                    </td>
                    <td className="border_right">My Property (%)</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.OccMyProperty
                          }
                          onChange={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Sunday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.OccMyProperty ? (
                        tableDataRefSecond.current.Sunday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-chg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Sunday?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Sunday?.OccMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.OccMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Monday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Monday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.OccMyProperty ? (
                        tableDataRefSecond.current.Monday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Monday?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Monday?.OccMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "tuseday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuseday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.OccMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Tuesday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.OccMyProperty ? (
                        tableDataRefSecond.current.Tuesday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Tuesday?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Tuesday?.OccMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.OccMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Wednesday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.OccMyProperty ? (
                        tableDataRefSecond.current.Wednesday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Wednesday
                          ?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Wednesday?.OccMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.OccMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Thursday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.OccMyProperty ? (
                        tableDataRefSecond.current.Thursday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Thursday?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Thursday?.OccMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.OccMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Friday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Friday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.OccMyProperty ? (
                        tableDataRefSecond.current.Friday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Friday?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Friday?.OccMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.OccMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.OccMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccMyPropertyChange
                                    ? parseFloat(item.OccMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccMyProperty");
                            tableDataRefSecond.current.Saturday.OccMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.OccMyProperty ? (
                        tableDataRefSecond.current.Saturday?.OccMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.OccMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.OccMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccMyProperty
                                    ? parseFloat(item.OccMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.OccMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.OccMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.OccMyPropertyChange ? (
                        tableDataRefSecond.current.Saturday?.OccMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.OccMyPropertyLy
                        ? tableDataRefSecond.current.Saturday?.OccMyPropertyLy
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("OccMyProperty")} */}
                      {tableDataRefSecond.current.Total?.OccMyProperty
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.OccMyProperty
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("OccMyProperty")} */}
                      {tableDataRefSecond.current.Total?.OccMyPropertyChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.OccMyPropertyChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  <tr className="shadowOnHover">
                    <td className="border_right">Comp Set (%)</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Sunday?.OccCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Sunday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.OccCompset ? (
                        tableDataRefSecond.current.Sunday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Sunday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.OccCompsetLy
                        ? tableDataRefSecond.current.Sunday?.OccCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Monday?.OccCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Monday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Monday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.OccCompset ? (
                        tableDataRefSecond.current.Monday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Monday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.OccCompsetLy
                        ? tableDataRefSecond.current.Monday?.OccCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Tuesday?.OccCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Tuesday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.OccCompset ? (
                        tableDataRefSecond.current.Tuesday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Tuesday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.OccCompsetLy
                        ? tableDataRefSecond.current.Tuesday?.OccCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.OccCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Wednesday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday?.OccCompset ? (
                        tableDataRefSecond.current.Wednesday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Wednesday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.OccCompsetLy
                        ? tableDataRefSecond.current.Wednesday?.OccCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.OccCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Thursday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.OccCompset ? (
                        tableDataRefSecond.current.Thursday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Thursday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.OccCompsetLy
                        ? tableDataRefSecond.current.Thursday?.OccCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Friday?.OccCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Friday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Friday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.OccCompset ? (
                        tableDataRefSecond.current.Friday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Friday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.OccCompsetLy
                        ? tableDataRefSecond.current.Friday?.OccCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.OccCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.OccCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccCompsetChange
                                    ? parseFloat(item.OccCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccCompset");
                            tableDataRefSecond.current.Saturday.OccCompset =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.OccCompset ? (
                        tableDataRefSecond.current.Saturday?.OccCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.OccCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.OccCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccCompset
                                    ? parseFloat(item.OccCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.OccCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.OccCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.OccCompsetChange ? (
                        tableDataRefSecond.current.Saturday?.OccCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.OccCompsetLy
                        ? tableDataRefSecond.current.Saturday?.OccCompsetLy
                        : 0}
                    </td>
                    {/* <td className="fontBold">{calculateAvg("OccCompset")}</td> */}
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.OccCompset
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.OccCompset
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.OccCompsetChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.OccCompsetChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  <tr className="shadowOnHover">
                    <td className="border_right">Index (MPI)</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Sunday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Sunday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.OccIndex ? (
                        tableDataRefSecond.current.Sunday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.OccIndexChange ? (
                        tableDataRefSecond.current.Sunday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.OccIndexLy
                        ? tableDataRefSecond.current.Sunday?.OccIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Monday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Monday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Monday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.OccIndex ? (
                        tableDataRefSecond.current.Monday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.OccIndexChange ? (
                        tableDataRefSecond.current.Monday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.OccIndexLy
                        ? tableDataRefSecond.current.Monday?.OccIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Tuesday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Tuesday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.OccIndex ? (
                        tableDataRefSecond.current.Tuesday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.OccIndexChange ? (
                        tableDataRefSecond.current.Tuesday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.OccIndexLy
                        ? tableDataRefSecond.current.Tuesday?.OccIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Wednesday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Wednesday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday?.OccIndex ? (
                        tableDataRefSecond.current.Wednesday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.OccIndexChange ? (
                        tableDataRefSecond.current.Wednesday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.OccIndexLy
                        ? tableDataRefSecond.current.Wednesday?.OccIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Thursday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Thursday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.OccIndex ? (
                        tableDataRefSecond.current.Thursday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.OccIndexChange ? (
                        tableDataRefSecond.current.Thursday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.OccIndexLy
                        ? tableDataRefSecond.current.Thursday?.OccIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Friday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Friday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Friday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.OccIndex ? (
                        tableDataRefSecond.current.Friday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.OccIndexChange ? (
                        tableDataRefSecond.current.Friday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.OccIndexLy
                        ? tableDataRefSecond.current.Friday?.OccIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Saturday?.OccIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.OccIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.OccIndexChange
                                    ? parseFloat(item.OccIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("OccIndex");
                            tableDataRefSecond.current.Saturday.OccIndex =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.OccIndex ? (
                        tableDataRefSecond.current.Saturday?.OccIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "occ",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "occ" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.OccIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.OccIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.OccIndex
                                    ? parseFloat(item.OccIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.OccIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.OccIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.OccIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.OccIndexChange ? (
                        tableDataRefSecond.current.Saturday?.OccIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.OccIndexLy
                        ? tableDataRefSecond.current.Saturday?.OccIndexLy
                        : 0}
                    </td>
                    {/* <td className="fontBold">{calculateAvg("OccIndex")}</td> */}
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.OccIndex
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.OccIndex
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.OccIndexChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.OccIndexChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>

                  {/* ADR */}
                  <tr className="shadowOnHover">
                    <td rowSpan={3} className="th-with-rowspan border_right">
                      ADR
                    </td>
                    <td className="border_right">My Property</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Sunday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.AdrMyProperty ? (
                        tableDataRefSecond.current.Sunday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-chg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Sunday?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Sunday?.AdrMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Monday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Monday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.AdrMyProperty ? (
                        tableDataRefSecond.current.Monday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Monday?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Monday?.AdrMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "tuseday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuseday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Tuesday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.AdrMyProperty ? (
                        tableDataRefSecond.current.Tuesday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Tuesday?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Tuesday?.AdrMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Wednesday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.AdrMyProperty ? (
                        tableDataRefSecond.current.Wednesday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Wednesday
                          ?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Wednesday?.AdrMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Thursday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.AdrMyProperty ? (
                        tableDataRefSecond.current.Thursday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Thursday?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Thursday?.AdrMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Friday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Friday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.AdrMyProperty ? (
                        tableDataRefSecond.current.Friday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Friday?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Friday?.AdrMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.AdrMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.AdrMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrMyPropertyChange
                                    ? parseFloat(item.AdrMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrMyProperty");
                            tableDataRefSecond.current.Saturday.AdrMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.AdrMyProperty ? (
                        tableDataRefSecond.current.Saturday?.AdrMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.AdrMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.AdrMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrMyProperty
                                    ? parseFloat(item.AdrMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.AdrMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.AdrMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.AdrMyPropertyChange ? (
                        tableDataRefSecond.current.Saturday?.AdrMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.AdrMyPropertyLy
                        ? tableDataRefSecond.current.Saturday?.AdrMyPropertyLy
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("AdrMyProperty")} */}
                      {tableDataRefSecond.current.Total?.AdrMyProperty
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.AdrMyProperty
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("AdrMyProperty")} */}
                      {tableDataRefSecond.current.Total?.AdrMyPropertyChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.AdrMyPropertyChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  <tr className="shadowOnHover">
                    <td className="border_right">Comp Set</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Sunday?.AdrCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Sunday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.AdrCompset ? (
                        tableDataRefSecond.current.Sunday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Sunday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Sunday?.AdrCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Monday?.AdrCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Monday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Monday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.AdrCompset ? (
                        tableDataRefSecond.current.Monday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Monday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Monday?.AdrCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Tuesday?.AdrCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Tuesday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.AdrCompset ? (
                        tableDataRefSecond.current.Tuesday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Tuesday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Tuesday?.AdrCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.AdrCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Wednesday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday?.AdrCompset ? (
                        tableDataRefSecond.current.Wednesday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Wednesday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Wednesday?.AdrCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.AdrCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Thursday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.AdrCompset ? (
                        tableDataRefSecond.current.Thursday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Thursday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Thursday?.AdrCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Friday?.AdrCompset}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Friday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Friday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.AdrCompset ? (
                        tableDataRefSecond.current.Friday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Friday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Friday?.AdrCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.AdrCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.AdrCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrCompsetChange
                                    ? parseFloat(item.AdrCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrCompset");
                            tableDataRefSecond.current.Saturday.AdrCompset =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.AdrCompset ? (
                        tableDataRefSecond.current.Saturday?.AdrCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.AdrCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.AdrCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrCompset
                                    ? parseFloat(item.AdrCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.AdrCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.AdrCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.AdrCompsetChange ? (
                        tableDataRefSecond.current.Saturday?.AdrCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.AdrCompsetLy
                        ? tableDataRefSecond.current.Saturday?.AdrCompsetLy
                        : 0}
                    </td>
                    {/* <td className="fontBold">{calculateAvg("AdrCompset")}</td> */}
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.AdrCompset
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.AdrCompset
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.AdrCompsetChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.AdrCompsetChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  <tr className="shadowOnHover">
                    <td className="border_right">Index (ARI)</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Sunday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Sunday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.AdrIndex ? (
                        tableDataRefSecond.current.Sunday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.AdrIndexChange ? (
                        tableDataRefSecond.current.Sunday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.AdrIndexLy
                        ? tableDataRefSecond.current.Sunday?.AdrIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Monday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Monday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Monday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.AdrIndex ? (
                        tableDataRefSecond.current.Monday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.AdrIndexChange ? (
                        tableDataRefSecond.current.Monday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.AdrIndexLy
                        ? tableDataRefSecond.current.Monday?.AdrIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Tuesday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Tuesday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.AdrIndex ? (
                        tableDataRefSecond.current.Tuesday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.AdrIndexChange ? (
                        tableDataRefSecond.current.Tuesday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.AdrIndexLy
                        ? tableDataRefSecond.current.Tuesday?.AdrIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Wednesday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Wednesday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday?.AdrIndex ? (
                        tableDataRefSecond.current.Wednesday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.AdrIndexChange ? (
                        tableDataRefSecond.current.Wednesday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.AdrIndexLy
                        ? tableDataRefSecond.current.Wednesday?.AdrIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Thursday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Thursday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.AdrIndex ? (
                        tableDataRefSecond.current.Thursday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.AdrIndexChange ? (
                        tableDataRefSecond.current.Thursday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.AdrIndexLy
                        ? tableDataRefSecond.current.Thursday?.AdrIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Friday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Friday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Friday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.AdrIndex ? (
                        tableDataRefSecond.current.Friday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.AdrIndexChange ? (
                        tableDataRefSecond.current.Friday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.AdrIndexLy
                        ? tableDataRefSecond.current.Friday?.AdrIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Saturday?.AdrIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.AdrIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.AdrIndexChange
                                    ? parseFloat(item.AdrIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("AdrIndex");
                            tableDataRefSecond.current.Saturday.AdrIndex =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.AdrIndex ? (
                        tableDataRefSecond.current.Saturday?.AdrIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "adr",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "adr" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.AdrIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.AdrIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.AdrIndex
                                    ? parseFloat(item.AdrIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.AdrIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.AdrIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.AdrIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.AdrIndexChange ? (
                        tableDataRefSecond.current.Saturday?.AdrIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.AdrIndexLy
                        ? tableDataRefSecond.current.Saturday?.AdrIndexLy
                        : 0}
                    </td>
                    {/* <td className="fontBold">{calculateAvg("AdrIndex")}</td> */}
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.AdrIndex
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.AdrIndex
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.AdrIndexChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.AdrIndexChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>

                  {/* REVPAR */}
                  <tr className="shadowOnHover">
                    <td rowSpan={3} className="th-with-rowspan border_right">
                      RevPAR
                    </td>
                    <td className="border_right">My Property</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Sunday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Sunday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-chg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Sunday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Sunday?.RevparMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Monday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Monday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Monday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Monday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Monday?.RevparMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "tuseday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuseday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Tuesday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Tuesday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Tuesday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Tuesday?.RevparMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Wednesday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Wednesday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Wednesday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Wednesday
                            ?.RevparMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Thursday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Thursday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Thursday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Thursday
                            ?.RevparMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Friday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Friday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Friday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Friday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Friday?.RevparMyPropertyLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.RevparMyProperty
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.RevparMyProperty = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparMyPropertyChange
                                    ? parseFloat(item.RevparMyPropertyChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparMyProperty");
                            tableDataRefSecond.current.Saturday.RevparMyProperty =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.RevparMyProperty ? (
                        tableDataRefSecond.current.Saturday?.RevparMyProperty
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "myProperty",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "myProperty" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.RevparMyPropertyChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.RevparMyPropertyChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparMyProperty
                                    ? parseFloat(item.RevparMyProperty)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparMyPropertyLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.RevparMyPropertyChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.RevparMyPropertyLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.RevparMyPropertyChange ? (
                        tableDataRefSecond.current.Saturday
                          ?.RevparMyPropertyChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.RevparMyPropertyLy
                        ? tableDataRefSecond.current.Saturday
                            ?.RevparMyPropertyLy
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("RevparMyProperty")} */}
                      {tableDataRefSecond.current.Total?.RevparMyProperty
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.RevparMyProperty
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("RevparMyProperty")} */}
                      {tableDataRefSecond.current.Total?.RevparMyPropertyChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.RevparMyPropertyChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  <tr className="shadowOnHover">
                    <td className="border_right">Comp Set</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Sunday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.RevparCompset ? (
                        tableDataRefSecond.current.Sunday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Sunday?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Sunday?.RevparCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Monday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Monday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.RevparCompset ? (
                        tableDataRefSecond.current.Monday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Monday?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Monday?.RevparCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Tuesday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.RevparCompset ? (
                        tableDataRefSecond.current.Tuesday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Tuesday?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Tuesday?.RevparCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Wednesday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.RevparCompset ? (
                        tableDataRefSecond.current.Wednesday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Wednesday
                          ?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Wednesday?.RevparCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Thursday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.RevparCompset ? (
                        tableDataRefSecond.current.Thursday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Thursday?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Thursday?.RevparCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Friday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Friday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.RevparCompset ? (
                        tableDataRefSecond.current.Friday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Friday?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Friday?.RevparCompsetLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.RevparCompset
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.RevparCompset = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparCompsetChange
                                    ? parseFloat(item.RevparCompsetChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparCompset");
                            tableDataRefSecond.current.Saturday.RevparCompset =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.RevparCompset ? (
                        tableDataRefSecond.current.Saturday?.RevparCompset
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "compSet",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "compSet" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.RevparCompsetChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.RevparCompsetChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparCompset
                                    ? parseFloat(item.RevparCompset)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparCompsetLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.RevparCompsetChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.RevparCompsetLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.RevparCompsetChange ? (
                        tableDataRefSecond.current.Saturday?.RevparCompsetChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.RevparCompsetLy
                        ? tableDataRefSecond.current.Saturday?.RevparCompsetLy
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("RevparCompset")} */}
                      {tableDataRefSecond.current.Total?.RevparCompset
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.RevparCompset
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {/* {calculateAvg("RevparCompset")} */}
                      {tableDataRefSecond.current.Total?.RevparCompsetChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.RevparCompsetChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                  <tr className="shadowOnHover">
                    <td className="border_right">Index (RGI)</td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Sunday?.RevparIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Sunday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday?.RevparIndex ? (
                        tableDataRefSecond.current.Sunday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "sunday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "sunday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "total-avg", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Sunday?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Sunday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Sunday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Sunday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Sunday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Sunday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Sunday?.RevparIndexLy
                        ? tableDataRefSecond.current.Sunday?.RevparIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Monday?.RevparIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Monday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Monday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday?.RevparIndex ? (
                        tableDataRefSecond.current.Monday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "monday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "monday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Monday?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Monday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Monday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Monday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Monday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Monday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Monday?.RevparIndexLy
                        ? tableDataRefSecond.current.Monday?.RevparIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday?.RevparIndex
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Tuesday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday?.RevparIndex ? (
                        tableDataRefSecond.current.Tuesday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "tuesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "tuesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Tuesday
                              ?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Tuesday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Tuesday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Tuesday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Tuesday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Tuesday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Tuesday?.RevparIndexLy
                        ? tableDataRefSecond.current.Tuesday?.RevparIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday?.RevparIndex
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Wednesday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday?.RevparIndex ? (
                        tableDataRefSecond.current.Wednesday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "wednesday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "wednesday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Wednesday
                              ?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Wednesday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Wednesday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Wednesday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Wednesday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Wednesday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Wednesday?.RevparIndexLy
                        ? tableDataRefSecond.current.Wednesday?.RevparIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday?.RevparIndex
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Thursday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday?.RevparIndex ? (
                        tableDataRefSecond.current.Thursday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "thursday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "thursday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Thursday
                              ?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Thursday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Thursday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Thursday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Thursday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Thursday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Thursday?.RevparIndexLy
                        ? tableDataRefSecond.current.Thursday?.RevparIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={tableDataRefSecond.current.Friday?.RevparIndex}
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Friday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Friday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday?.RevparIndex ? (
                        tableDataRefSecond.current.Friday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "friday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "friday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Friday?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Friday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Friday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Friday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Friday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Friday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Friday?.RevparIndexLy
                        ? tableDataRefSecond.current.Friday?.RevparIndexLy
                        : 0}
                    </td>

                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "curr",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "curr" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday?.RevparIndex
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.RevparIndex = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let changeValue = item?.RevparIndexChange
                                    ? parseFloat(item.RevparIndexChange)
                                    : 0;
                                  lyValue = (
                                    (newValue * 100) /
                                    (100 + changeValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            calculateAvg("RevparIndex");
                            tableDataRefSecond.current.Saturday.RevparIndex =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday?.RevparIndex ? (
                        tableDataRefSecond.current.Saturday?.RevparIndex
                      ) : (
                        0
                      )}
                    </td>
                    <td
                    //   onDoubleClick={() => {
                    //     setClickedTr({
                    //       mainRow: "rev",
                    //       subRow: "index",
                    //       field: "change",
                    //       day: "saturday",
                    //     });
                    //   }}
                    >
                      {clickedTr.mainRow === "rev" &&
                      clickedTr.subRow === "index" &&
                      clickedTr.field === "change" &&
                      clickedTr.day === "saturday" ? (
                        <Form.Control id={commonService.generateGlobalClickTrackerID("RunningStar", "form-control-onchange", propertyCode)}
                          maxLength={8}
                          type="text"
                          className="small-padding width50"
                          value={
                            tableDataRefSecond.current.Saturday
                              ?.RevparIndexChange
                          }
                          onChange={(e) => {
                            let lyValue = "";
                            strDataRef.current = strDataRef.current?.map(
                              (item, index) => {
                                if (item?.Weekday === "Saturday") {
                                  item.RevparIndexChange = e.target.value;

                                  let newValue = e.target.value
                                    ? parseFloat(e.target.value)
                                    : 0;
                                  let currValue = item?.RevparIndex
                                    ? parseFloat(item.RevparIndex)
                                    : 0;
                                  lyValue = (
                                    (currValue * 100) /
                                    (100 + newValue)
                                  )?.toFixed(2);
                                  item.RevparIndexLy = lyValue;
                                }
                                return item;
                              }
                            );
                            tableDataRefSecond.current.Saturday.RevparIndexChange =
                              e.target.value;
                            tableDataRefSecond.current.Saturday.RevparIndexLy =
                              lyValue;
                            setStrData(strDataRef.current);
                          }}
                        />
                      ) : tableDataRefSecond.current.Saturday
                          ?.RevparIndexChange ? (
                        tableDataRefSecond.current.Saturday?.RevparIndexChange
                      ) : (
                        0
                      )}
                    </td>
                    <td className="border_right">
                      {tableDataRefSecond.current.Saturday?.RevparIndexLy
                        ? tableDataRefSecond.current.Saturday?.RevparIndexLy
                        : 0}
                    </td>
                    {/* <td className="fontBold">{calculateAvg("RevparIndex")}</td> */}
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.RevparIndex
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.RevparIndex
                          )?.toFixed(2)
                        : 0}
                    </td>
                    <td className="fontBold">
                      {tableDataRefSecond.current.Total?.RevparIndexChange
                        ? parseFloat(
                            tableDataRefSecond.current.Total?.RevparIndexChange
                          )?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td>No Data Found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* <div className="running-report-div mb-3 mt-3">
                <div></div>
                <div className="weekly-report-heading">
                    <p>
                        WARNING: You must click the "Save" button if you make any changes in running 28 days (by day of week)
                    </p>
                </div>
                {submitLoading ? (
                    <button
                        className="default-btn primary-btn width75"
                        type="button"
                        disabled
                    >
                        <span
                            className="spinner-border spinner-border-sm "
                            role="status"
                            aria-hidden="true"
                        ></span>
                
                    </button>
                ) : (
                    <button
                        className="default-btn primary-btn width75"
                        onClick={() => {
                            handleSave();
                        }}
                    >
                        Save
                    </button>
                )}
            </div> */}

      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default RunningStar;
